module.exports = __webpack_public_path__ + "media/images/hackerrank/devops-299db8204d1e09b6d078932bba5d47ef.png";